import { Modal } from "../ui/modal";
import Spinner from "../ui/Spinner/Spinner";
import { AlertTriangle } from "lucide-react";

interface Props {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText: string;
  cancelText?: string;
  loading?: boolean;
  error?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmModal = ({
  isOpen,
  title,
  message,
  confirmText,
  cancelText = "Go back",
  loading = false,
  error,
  onConfirm,
  onCancel,
}: Props) => (
  <Modal
    isOpen={isOpen}
    onClose={loading ? () => {} : onCancel}
    className="max-w-sm rounded-2xl border border-gray-200 bg-white p-6 shadow-xl dark:border-gray-800 dark:bg-gray-900 dark:shadow-2xl"
  >
    <div className="text-center">
      <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/30">
        <AlertTriangle className="h-6 w-6 text-red-600 dark:text-red-400" />
      </div>
      <h2 className="mb-2 text-lg font-semibold text-gray-800 dark:text-white/90">
        {title}
      </h2>
      <p className="mb-4 text-sm text-gray-500 dark:text-gray-400">{message}</p>

      {error && (
        <p className="mb-4 text-sm text-red-600 dark:text-red-400">{error}</p>
      )}

      <div className="flex flex-col gap-3">
        <button
          onClick={onConfirm}
          disabled={loading}
          className="rounded-lg bg-red-600 px-4 py-3 text-sm font-medium text-white transition-colors hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-50"
        >
          {loading ? (
            <span className="flex items-center justify-center gap-2">
              <Spinner className="h-4 w-4" />
              Please wait...
            </span>
          ) : (
            confirmText
          )}
        </button>
        <button
          onClick={onCancel}
          disabled={loading}
          className="rounded-lg border border-gray-300 bg-white px-4 py-3 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-100 disabled:opacity-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700"
        >
          {cancelText}
        </button>
      </div>
    </div>
  </Modal>
);

export default ConfirmModal;
